<template>
  <div class="expandDiv">
    <div v-if="getRowArr.length > 0">
      <!-- 以下为测试删除代码 -->
      <Table :columns="columns" :data="getRowArr">
        <template slot-scope="{ row, index }" slot="name">
          {{ accountName }}
        </template>
        <template slot-scope="{ row, index }" slot="id">
          {{ accountIdString }}
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Array,
    accountIdString: String,
    accountName: String
  },
  data() {
    return {
      getRowArr: [],
      columns: [
        {
          type: "expand",
          width: 30,
          render: (h, params) => {}
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountName"),
          key: "",
          minWidth: 120,
          slot: "name"
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountID"),
          key: "",
          minWidth: 120,
          slot: "id"
        },
        {
          title: this.$t("DocDBMonitor.ClusterIdentifier"),
          key: "dbInstanceIdentifier",
          minWidth: 150
        },
        {
          title: this.$t("DocDBMonitor.role"),
          key: "roleName",
          minWidth: 80
        },
        {
          title: this.$t("DocDBMonitor.EngineVersion"),
          key: "engineVersion",
          minWidth: 150
        },
        {
          title: this.$t("DocDBMonitor.AreasAndZones"),
          key: "availabilityZone",
          minWidth: 160
        },
        {
          title: this.$t("DocDBMonitor.status"),
          key: "status",
          minWidth: 80
        },

        {
          title: this.$t("DocDBMonitor.size"),
          key: "dbInstanceClass",
          minWidth: 80
        }
      ]
    };
  },
  watch: {
    row: {
      handler(newName, oldName) {
        this.getRowArr = newName;
      },
      immediate: true
    }
  },
  mounted() {},
  created() {}
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
.expandDiv >>> .ivu-table-header thead tr {
  display: none;
}
.expandDiv >>> .ivu-table-wrapper {
  /* border: none; */
  border-top-color: #fff;
  border-left-color: #fff;
  border-bottom-color: #fff;
}
.expandDiv >>> .ivu-table-expanded-cell {
  padding: 0;
}
.expandDiv >>> .ivu-table td {
  padding: 0 !important;
  border-bottom: none;
}
.expandDiv >>> .ivu-table-cell-with-expand {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/DocDBMonitor/TableExpandSet.vue